import React from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";

import Login from "../Pages/Auth/LoginPage/Login";
import Register from "../Pages/Auth/RegisterPage/Register";
import OTPVerification from "../Pages/Auth/LoginPage/OtpPage/OTPVerification";
import HomePage from "../Pages/HomePage/HomePage";
import Profile from "../Pages/Profile/Profile";
import Header from "../Components/Header/Header";
import Professional from "../Pages/Professional/Professional";
import ServiceDetails from "../Pages/ServiceDetails/ServiceDetails";
import Workers from "../Pages/Workers/Workers";
import Jobs from "../Pages/Jobs/Jobs/Jobs";
import CreateJobPost from "../Pages/Jobs/CreateJobPost/CreateJobPost";

import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute"; // ✅ import

const AppRoutes = () => {
   const isAuthenticated = useSelector((state) => state.login.isAuthenticated);
  return (
    <>
       {isAuthenticated && <Header />}
      
       <div className={isAuthenticated ? "pt-20" : ""}>
        <Routes>
          {/* Public routes with redirection if already authenticated */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />
          <Route
            path="/register"
            element={
              <PublicRoute>
                <Register />
              </PublicRoute>
            }
          />
          <Route
            path="/otp"
            element={
              <PublicRoute>
                <OTPVerification />
              </PublicRoute>
            }
          />

          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/professional"
            element={
              <ProtectedRoute>
                <Professional />
              </ProtectedRoute>
            }
          />
          <Route
            path="/serviceDetails/:worker_id"
            element={
              <ProtectedRoute>
                <ServiceDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/worker"
            element={
              <ProtectedRoute>
                <Workers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs"
            element={
              <ProtectedRoute>
                <Jobs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/createJob"
            element={
              <ProtectedRoute>
                <CreateJobPost />
              </ProtectedRoute>
            }
          />
        </Routes>
      </div>
    </>
  );
};

export default AppRoutes;
